import script from "./CBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CBadge.vue?vue&type=script&setup=true&lang=js"

import "./CBadge.vue?vue&type=style&index=0&id=37055eca&lang=scss"

const __exports__ = script;

export default __exports__